import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ShieldCheck } from "lucide-react";

const LOGO = "/gpm-logo.png";

export default function Footer() {
    return (
        <footer className="border-t border-white/5 bg-navy-950 mt-24" data-testid="main-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-1">
                    <div className="flex items-center gap-3">
                        <div className="w-14 h-14 flex items-center justify-center shrink-0">
                            <img
                                src={LOGO}
                                alt="Global Property Mart"
                                className="w-full h-full object-contain drop-shadow-[0_0_12px_rgba(218,165,32,0.3)]"
                            />
                        </div>
                        <div>
                            <div className="font-heading font-bold text-white">Global Property Mart</div>
                            <div className="text-[10px] tracking-[0.2em] uppercase text-gold-500/90 mt-1">One Platform · Every Need</div>
                        </div>
                    </div>
                    <p className="text-sm text-white/60 leading-relaxed mt-4">
                        India&apos;s most trusted property service ecosystem. Buy, sell, rent, verify, finance — one platform for every property need.
                    </p>
                    <div className="mt-6 flex items-center gap-2 px-3 py-2 rounded-md bg-gold-500/10 border border-gold-500/30 w-fit">
                        <ShieldCheck className="w-4 h-4 text-gold-500" />
                        <span className="text-xs font-medium text-gold-500">RERA-verified Network</span>
                    </div>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-4">Marketplace</h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><Link to="/properties?type=residential" className="hover:text-gold-500">Residential</Link></li>
                        <li><Link to="/properties?type=commercial" className="hover:text-gold-500">Commercial</Link></li>
                        <li><Link to="/properties?type=plot" className="hover:text-gold-500">Plots & Land</Link></li>
                        <li><Link to="/properties?type=farmland" className="hover:text-gold-500">Farmland</Link></li>
                        <li><Link to="/properties?listing=rent" className="hover:text-gold-500">Rentals</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-4">Services</h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><Link to="/brokers" className="hover:text-gold-500">Verified Brokers</Link></li>
                        <li><Link to="/advocates" className="hover:text-gold-500">Legal & Title Verification</Link></li>
                        <li><Link to="/loan-services" className="hover:text-gold-500">Home Loans</Link></li>
                        <li><Link to="/legal-services" className="hover:text-gold-500">Documentation</Link></li>
                        <li><Link to="/reviews" className="hover:text-gold-500">Reviews</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-gold-500 mb-4">Reach Us</h4>
                    <ul className="space-y-3 text-sm text-white/70">
                        <li className="flex items-center gap-2">
                            <Mail className="w-4 h-4 text-gold-500" />
                            <a href="mailto:globalpropertymart95@gmail.com" className="hover:text-gold-500">globalpropertymart95@gmail.com</a>
                        </li>
                    </ul>
                    <Link
                        to="/contact"
                        className="inline-block mt-5 px-4 py-2 border border-gold-500/40 text-gold-500 text-sm rounded-md hover:bg-gold-500/10"
                        data-testid="footer-contact-cta"
                    >
                        Contact Sales →
                    </Link>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
                    <div>© {new Date().getFullYear()} Global Property Mart. All rights reserved.</div>
                    <div className="flex gap-6 items-center">
                        <Link to="/privacy" data-testid="footer-privacy" className="hover:text-gold-500">Privacy</Link>
                        <Link to="/terms" data-testid="footer-terms" className="hover:text-gold-500">Terms</Link>
                        <Link to="/terms" className="hover:text-gold-500">Refund Policy</Link>
                        <Link
                            to="/admin-login"
                            data-testid="footer-admin-login"
                            className="text-white/25 hover:text-gold-500 text-[10px] uppercase tracking-widest"
                        >
                            Admin
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
